import React from 'react';
import PropTypes from 'prop-types';

import { ReactComponent as IconCheckbox } from '../../assets/icon/ic_checkbox.svg';

const Checkbox = ({
  name, text, isActive, onChange, styleContainer, disabled
}) => {
  return (
    <div
      className={`flex items-center justify-start h-max ${styleContainer || ''}
      ${disabled ? 'opacity-30' : ''}`}
    >
      <label htmlFor={name} className="flex items-center gap-[8px] cursor-pointer select-none">
        <IconCheckbox
          className={`${isActive ? 'text-white fill-primary' : 'text-whiteHover fill-whiteHover'}
          transition-all duration-200 w-[18px] h-[18px] shrink-0`}
        />
        <input
          disabled={disabled}
          className="w-0 h-0 overflow-hidden opacity-0"
          type="checkbox"
          name={name}
          id={name}
          checked={isActive}
          onChange={() => !disabled && onChange()}
        />
        <span className="text-[14px] font-medium text-romanSilver capitalize">
          {text}
        </span>
      </label>
    </div>
  );
};

Checkbox.propTypes = {
  name: PropTypes.string.isRequired,
  text: PropTypes.node,
  styleContainer: PropTypes.string,
  isActive: PropTypes.bool,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
};

Checkbox.defaultProps = {
  text: undefined,
  styleContainer: undefined,
  isActive: false,
  disabled: false,
  onChange: () => {}
};

export default Checkbox;
